import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Handle, Position } from 'reactflow';

import styles from '../EntrySourceNode.module.scss';
import Transaction from '../../../../../assets/icons/flows/transaction.svg';
import Edit from '../../../../../assets/icons/flows/edit.svg';
import Delete from '../../../../../assets/icons/flows/delete.svg';
import { handle, right } from '../../../../../utils/flows';
import {
  clearActiveSettings,
  deleteSettings,
  selectConfigsList,
  selectErrors,
  selectFlowStatus,
  setActiveSettings,
} from '../../../../../store/reducers/flows';
import Alert from '../../../../../assets/icons/flows/alert.svg';
import Tooltip from '../../../../../components/ui/Tooltip';
import Divider from '../../../../../assets/icons/divider.svg';
import { truncateAddress } from '../../../../../utils/web3/truncateAddress';
import { capitalizeFirstLetter } from '../../../../../utils/capitalizeFirstLetter';

const TransactionNode = ({ ...props }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const [onNodeHover, setOnNodeHover] = useState(false);
  const [completed, setCompleted] = useState(false);

  const configList = useSelector(selectConfigsList);
  const errors = useSelector(selectErrors);
  const status = useSelector(selectFlowStatus);

  const filteredErrors = () =>
    errors.length && errors.filter((elem) => elem.node_id === props.id);

  const chooseAssets = (arr) => {
    if (arr && arr.length > 1) {
      return 'Multiple';
    }
    if (arr && arr.length === 1) {
      return arr[0]?.name || arr[0]?.value;
    }
    return null;
  };

  const chooseChain = (arr) => {
    if (arr && arr.length > 1) {
      return 'Multiple';
    }
    if (arr && arr.length === 1) {
      return arr[0].blockchain;
    }
    return null;
  };

  useEffect(() => {
    if (configList.length) {
      const index = configList
        .map((object) => object.node_id)
        .indexOf(props.id);
      if (index >= 0) {
        setData(configList[index]);
      }
    }
  }, [configList, props.id]);

  useEffect(() => {
    if (
      data &&
      data.event &&
      ((data?.assets && data.assets.length) || data.contract_address) &&
      data.asset_type
    ) {
      if (data.asset_type === 'Token' || data.asset_type === 'NFT') {
        setCompleted(true);
      }
    } else {
      setCompleted(false);
    }
  }, [data]);

  return (
    <>
      <div
        className={`
        ${styles.wrapper}
        ${data && ((data?.assets && data.assets.length) || data.contract_address) ? styles.size120 : ''}
        ${status === 'running' || status === 'scheduled' || status === 'stopped' ? 'cursor-pointer' : ''}
        d-flex
        flex-column
        justify-content-center
        `}
        onMouseEnter={() => setOnNodeHover(true)}
        onMouseLeave={() => setOnNodeHover(false)}
        role="presentation"
        onClick={() => {
          if (
            status === 'running' ||
            status === 'scheduled' ||
            status === 'stopped'
          ) {
            dispatch(
              setActiveSettings({ type: 'transactionNode', node_id: props.id })
            );
          }
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          {status !== 'running' &&
          status !== 'stopped' &&
          status !== 'scheduled' ? (
            <>
              {!completed || filteredErrors().length ? (
                <>
                  <div
                    className={styles.alert}
                    data-for={`${props.id}_error`}
                    data-tip
                  >
                    <Alert />
                  </div>
                  {filteredErrors().length ? (
                    <Tooltip
                      id={`${props.id}_error`}
                      info={`${filteredErrors()[0].detail}`}
                      position="right"
                    />
                  ) : null}
                </>
              ) : null}
              <div className={onNodeHover ? styles.delete : styles.delete_hide}>
                <Delete
                  onClick={() => {
                    props.data.onRemove(props.id);
                    dispatch(deleteSettings(props.id));
                    dispatch(clearActiveSettings());
                  }}
                />
              </div>
            </>
          ) : null}
          <div className={`${styles.title} d-flex align-items-center gap-2`}>
            <Transaction />
            <div className={styles.description}>
              {(data && data.name) || 'New transaction source'}
            </div>
          </div>
          <div className="ms-2 cursor-pointer">
            <Edit
              onClick={() =>
                dispatch(
                  setActiveSettings({
                    type: 'transactionNode',
                    node_id: props.id,
                  })
                )
              }
            />
          </div>
        </div>
        {data &&
        ((data?.assets && data.assets.length) ||
          data.contract_address ||
          data.blockchain) ? (
          <div>
            <div className={`${styles.divider} d-flex`}>
              <Divider />
            </div>
            <div className={`${styles.info} d-flex justify-content-center`}>
              <div
                className={`${styles.info_col} d-flex flex-column align-items-center justify-content-center`}
              >
                <div>{data.event || '?'}</div>
                <div className="text-nowrap">Action</div>
              </div>
              <div
                className={`${styles.info_col} d-flex flex-column align-items-center justify-content-center`}
              >
                <div className={`text-truncate ${styles.asset}`}>
                  {chooseAssets(data.assets) ||
                    truncateAddress(data.contract_address)}
                </div>
                <div>
                  {data?.assets
                    ? data.assets.length === 1
                      ? data.asset_type
                      : `${data.asset_type}s`
                    : data.asset_type}
                </div>
              </div>
              <div
                className={`${styles.info_col} d-flex flex-column align-items-center justify-content-center`}
              >
                <div className={`text-truncate ${styles.asset}`}>
                  {capitalizeFirstLetter(chooseChain(data.assets)) || '?'}
                </div>
                <div>Blockchain</div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Handle
        type="source"
        id="transactionOutput"
        position={Position.Right}
        style={{ ...handle, ...right }}
      />
    </>
  );
};

export default TransactionNode;
